
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Connection","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"id":"Rectangle_15348","data-name":"Rectangle 15348","width":"30","height":"30","fill":"none"}}),_c('g',{attrs:{"id":"Group_45655","data-name":"Group 45655"}},[_c('g',{attrs:{"id":"Group_45661","data-name":"Group 45661"}},[_c('path',{attrs:{"id":"Path_32798","data-name":"Path 32798","d":"M17.073 19.589l-1.511-1.51 1.415-1.4a.751.751 0 000-1.061.751.751 0 00-1.059 0l-1.418 1.4-1.583-1.583 1.414-1.4a.751.751 0 000-1.061.751.751 0 00-1.059 0l-1.418 1.406-1.447-1.446a.75.75 0 00-1.061 0L7.578 14.7a4.469 4.469 0 000 6.312l.175.175-2.7 2.7A.75.75 0 006.11 24.95l2.7-2.7.175.176a4.469 4.469 0 006.312 0l1.772-1.772a.752.752 0 000-1.061m-2.829 1.768a2.966 2.966 0 01-4.19 0l-.7-.7-.7-.7a2.966 2.966 0 010-4.19l1.242-1.241 1.442 1.442 4.157 4.156z"}}),_c('path',{attrs:{"id":"Path_32799","data-name":"Path 32799","d":"M22.423 8.989l-.175-.175 2.7-2.7A.75.75 0 0023.89 5.05l-2.7 2.7-.176-.175a4.468 4.468 0 00-6.311 0L12.928 9.35a.749.749 0 000 1.06l6.662 6.662a.749.749 0 001.06 0l1.772-1.772a4.468 4.468 0 000-6.311m-2.3 6.492l-5.6-5.6 1.242-1.242a2.966 2.966 0 014.19 0l1.411 1.412a2.965 2.965 0 010 4.189z"}})])])])
          )
        }
      }
    